import React from 'react';
import { css } from '@emotion/react';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import { color } from '../../styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const StyledCheckbox = css`
  padding: 6px;
`;

const CheckboxLabel = (isDisabled: boolean) => css`
  color: ${isDisabled ? color.thin_gray : color.black};
  cursor: ${isDisabled ? 'none' : 'pointer'};
`;

export const CareRecordUrineUrgencyCheckSection = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={AlignCenter}>
      <Checkbox
        id={'urine-urgency-checkbox'}
        css={StyledCheckbox}
        disabled={form.isUrineMetaDisabled}
        checked={form.isUrgency ?? false}
        onClick={form.handleCheckIsUrgency}
      />
      <label htmlFor={'urine-urgency-checkbox'} css={CheckboxLabel(form.isUrineMetaDisabled)}>
        {t('isUrgency', '切迫感')}
      </label>
    </div>
  );
};
